export default __webpack_public_path__ + "static/media/allocation-request.d264730e.png";